module.exports = __webpack_public_path__ + "static/img/03.0b69faf.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build08/assets/images/home/gamelist/03.png
// module id = iBSb
// module chunks = 43